<template>
  <div class="h-input-number">
    <div class="mini-btn minus"
         v-click-sound-button
         :disabled="value <= min"
         @click="handleMinus">-
    </div>
    <div class="input-field">
      <input spellcheck="false" type="text" :maxlength="maxlength" :value="value || 0" @blur="handleBlur">
    </div>
    <div class="mini-btn plus"
         v-click-sound-button
         :disabled="value >= max"
         @click="handleAdd">+
    </div>
  </div>
</template>


<script>
  export default {
    name: 'h-input-number',

    data () {
      return {
        creature: {}
      }
    },

    props: {
      value: {
        type: Number,
        default: 0,
      },
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: Number.MAX_SAFE_INTEGER,
      },
      maxlength: {
        type: Number,
        default: 256,
      },
    },

    methods: {
      handleMinus () {
        const v = Math.min(this.max, Math.max(this.min, this.value - 1))
        this.$emit('input', v)
      },

      handleBlur (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        const val = Math.min(this.max, Math.max(this.min, v))
        console.log('val', val)
        this.$emit('input', val)
        this.$forceUpdate()
      },

      handleAdd () {
        const v = Math.min(this.max, Math.max(this.min, this.value + 1))
        this.$emit('input', v)
      },
    },

  }
</script>


<style lang="stylus" scoped>
  .h-input-number
    display flex
    align-items center

  .input-field
    position relative
    flex-grow 1
    text-align right
    whiteText1()
    input
      position relative
      width 100%
      height 24px
      padding 0 2px
      border-top 1px solid #78624a
      border-bottom 1px solid #78624a
      border-radius 0
      line-height 22px
      font-size 12px
      text-align center
      letter-spacing 1px
      background-color rgba(0, 0, 0, 0.3)

  .mini-btn
    flex-shrink 0
    goldText1()
    z-index 1
    width 24px
    height 24px
    font-size 18px
    border 1px solid #78624a
    border-radius 2px 0 0 2px
    line-height 22px
    text-align center
    background-color #392519
    user-select none
    &.minus
      line-height 20px
    &.plus
      border-radius 0 2px 2px 0
    &:hover
      cursor pointer
      border-color lighten(#78624a, 10%)
      color darken($colorGold, 30%)
    &:active
      color darken($colorGold, 50%)

  .mini-btn[disabled]
    filter grayscale(1)
    cursor not-allowed

</style>
